import { Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AspHomeService } from './asp-home.service';
import { ToastrService } from 'ngx-toastr';
import { AspLoginService } from '../asp-login/asp-login.service';
import { fuseAnimations } from '@fuse/animations';
import { FormBuilder, FormGroup, Validators,AbstractControl, ValidatorFn} from '@angular/forms';
import { AspMakeComponent } from '../asp-make/asp-make.component';
import { AspModelComponent } from '../asp-model/asp-model.component';
import { AspYearComponent } from '../asp-year/asp-year.component';
import { AspVariantComponent } from '../asp-variant/asp-variant.component';
import { AspMakeService } from '../asp-make/asp-make.service';
import { AspDynamicPopupComponent } from '../asp-dynamic-popup/asp-dynamic-popup.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {SearchSuggestionService} from 'app/shared/search-suggestion.service'
import { locale } from 'moment';
import { GoogleAnalyticsService } from 'app/shared/google-analytics.service';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { GlobalVariable } from 'app/main/globals';
import { AspLoadingService } from '../asp-loading/asp-loading.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { AspInstantOrderComponent } from '../asp-instant-order/asp-instant-order.component';
// import { SpareKitSidebarComponent } from '../spare-kit-sidebar/spare-kit-sidebar.component';
import { Location } from '@angular/common';
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';
import { AspOrderListComponent } from '../asp-order-list/asp-order-list.component';
import { AspOrderDetailsComponent } from '../asp-order-details/asp-order-details.component';
import { AspMyRequestService } from '../asp-my-request/asp-my-request.service';


export function maxLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value && control.value.length > maxLength) {
      return { 'maxLength': { value: control.value } };
    }
    return null;
  };
}

interface SpareStock {
  partNumber: string;
  quantity: number;
  mrp: number;
  sellingPrice: number;
  discountType: string;
  discountAmount: number;
}

@Component({
  selector: 'app-asp-home',
  templateUrl: './asp-home.component.html',
  styleUrls: ['./asp-home.component.scss'],  
  animations: fuseAnimations
})
export class AspHomeComponent implements OnInit {  
  loading: boolean = false;
  spareSelectedGarageName: any;
  brands: any = [];
  categories: any = [];
  allCategories: any = [];
  veiwMoreCat: boolean = true;
  veiwLessCat: boolean = false;  
  formData: any = {}; 
  vehicleForm: FormGroup;  
  submitted = false;
  makeList: any = [];
  vehicleInfo: boolean = false;
  vehicleData: any = [];
  searchText = ''
  suggestions: string[] = [];
  selectedSuggestions: Set<string> = new Set<string>();
  isVisible: boolean;
  isConfirmationSidebarOpen: boolean;
  sharedCartKey: string = '';
  expandedProduct: number | null = null;
  brandSparesList: any[] = [];
  aspSpareAdded = [];
  msDotsArray: number[] = [];
  msActiveDotIndex: number = 0;
  vehicleType:any = localStorage.getItem('vehicleType');
  isShippingCharges:boolean = false;
  grandAmount: any;
  items: any=[];
  amount: any;
  addedCart = [];
  cartCount = 0;
  sparesDiscount: number;
  isAddedCart:boolean = false;
  isCartCount:boolean = false;
  shippingCharges: any;
  cartSubTotal = 0;
  serviceKitList: any[] = [];
  loadingServiceKit = false;
  cartGrandTotal = 0;  
  newData = {}; 
  whatsAppNumber: string = '918884998600';
  whatsAppMessage: string = 'Hi Team, help me with selecting the right spare parts.';
  components = {
    makeComp: AspMakeComponent,
    modelComp: AspModelComponent,
    yearComp: AspYearComponent,
    variantComp: AspVariantComponent
  };
  isMobile: boolean = false;
  isInputVisible: boolean;
  autoScrollInterval: any;
  autoScrollActive = true;
  showSharedWtemPopup = false;
  cartItems: any[] = [];
  cartList: any;
  isOpenMake: boolean= false;
  isOpenFull: boolean;
  magicPopup: boolean;
  totalSavings: number = 0;
  totalSavingsPercentage: any;
  totalPurchasePercentage: any;
  totalPurchase: number = 0;
  totalOrders: number = 0;
  oesPercentage: number = 0;
  isVehiclePopupOpen = false;
  // Lists
  recentOrdersList: any[] = [];
  requestProgressList: any[] = [];
  garageName: string = '';
  outStandings: number = 0;
  pendingQuoteApprove: number = 0;
  totalDues: number = 0;
  pendingCount: number = 0; 
  orderKey: any;
  month: any;
  marutibrandSectionList: any[] = [];
  selectedBrand: any;
  insurerGarageKey: string;
  insurance: any;
  isInsurance: boolean;
  selectedType: string;
  showError: boolean;
  selectedCompany: string;
  filteredList: string[];
  greeting: string = 'Good morning';
  insuranceCompanies: string[] = [
    'ICICI Lombard',
    'HDFC ERGO',
    'Bajaj Allianz',
    'Tata AIG',
    'New India Assurance'
  ];
  showError1: boolean;
  showPopupinfo: boolean;
  selectedRequestInsurance: string = '';
  openEdit: boolean;
openEditIndex: number | null = null;
  requestaId: any;
  insuranceGarageId: any;
  ismobile: any;
  totalSparesCount: any;
  kitItems: any;
  brandSectionList: any;


  constructor(
    private router: Router,
    private homeService: AspHomeService,
    public toastr: ToastrService,
    private aspLoginService: AspLoginService,    
    private _formBuilder: FormBuilder,
    private aspMakeService: AspMakeService,
    private aspMyRequestService: AspMyRequestService,
    private bottomSheet: MatBottomSheet,
    private breakpointObserver: BreakpointObserver,
    private searchSuggestionService:SearchSuggestionService,
    private resolver: ComponentFactoryResolver,
    private googleAnalyticsService: GoogleAnalyticsService,
    private aspCartService: AspCartService,
    private route: ActivatedRoute,
    private aspLoadingService: AspLoadingService,
     private _fuseConfigService: FuseConfigService,
     private location: Location
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    });}

  @ViewChild('popupSection') popupSection!: ElementRef;
  @ViewChild('productScroller', { static: false }) productScroller!: ElementRef;
  @ViewChild('slider', { static: false }) slider!: ElementRef;
  @ViewChild('msCategoryRow', { static: false })
  msCategoryRow!: ElementRef;
  

scrollProductsLeft() {
  if (!this.productScroller) return;

  this.productScroller.nativeElement.scrollBy({
    left: -320,
    behavior: 'smooth'
  });
}

scrollProductsRight() {
  if (!this.productScroller) return;

  this.productScroller.nativeElement.scrollBy({
    left: 320,
    behavior: 'smooth'
  });
}
  ngOnInit(): void { 
     this.setGreeting();
    this.callGarageMetrics();
    const isFindMyCar = localStorage.getItem('isFindMyCar') === '1';
    // this.aspLoadingService.show();
    // const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;

    // To hide
    // if(cartCountEl)
    //   cartCountEl.style.display = 'none';
    if (!isFindMyCar) {
      localStorage.removeItem('filterParams');
      localStorage.removeItem('selectedCategory');
      localStorage.removeItem('selectedBrands');
    }
    sessionStorage.removeItem('wishlist');
    sessionStorage.removeItem("suggestionMap");
    localStorage.removeItem('selectedRequestStatus');
    localStorage.removeItem('selectedRequestTime');
    localStorage.removeItem('isDynamicPopup'); 
    // localStorage.removeItem('registrationNumber');
    localStorage.removeItem('searchItems');
    localStorage.removeItem('selectedKits');
    localStorage.removeItem("selectedMake");
    localStorage.removeItem("selectedModel");
    localStorage.removeItem("selectedYear");
    localStorage.removeItem("rowKey" );
    localStorage.removeItem("variant" );
    localStorage.removeItem("imageUrlPath");
    localStorage.removeItem("registrationNumber");
    localStorage.removeItem("vehicleData");
    localStorage.removeItem("vin");
    this.loading = true;    
    this.vehicleForm = this._formBuilder.group({
        regNo: ['', [Validators.required,maxLengthValidator(13)]]
    });

    this.vehicleForm.get('regNo')?.valueChanges.subscribe(value => {
      if (value) {
        // this.vehicleForm.get('regNo')?.setValue(value.toUpperCase(), { emitEvent: false });
        const formattedValue = this.formatRegNo(value);
        this.vehicleForm.get('regNo')?.setValue(formattedValue, { emitEvent: false });
      }
    });
    
    this.aspLoginService.checkLogin();
    this.spareSelectedGarageName = localStorage.getItem("spareSelectedGarageName");
    this.getPopularBrandsAndCategory();
    this.getTopMake();
    // if(localStorage.getItem("garageKey")){
    //     this.magicPopup=true;
    // }
    this.vehicleData = JSON.parse(localStorage.getItem("vehicleData"));
    if(this.vehicleData){
      this.vehicleInfo = true;
      this.isOpenFull=true;
    }else{
      this.vehicleInfo = false;
      
    this.isOpenFull=false;
    }
    // ✅ Open popup when returning from VARIANT page
    if (localStorage.getItem('openVehiclePopup') === '1') {
      this.isOpenFull=true;
      // this.vehicleInfo = true;
      // this.isOpenFull = true;
      localStorage.removeItem('openVehiclePopup');
      setTimeout(() => {
        this.popupSection?.nativeElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }, 300);
    }


    if (window.innerWidth >= 768) {
      setTimeout(() => {
        this.autoScrollInterval = setInterval(() => {
          if (this.autoScrollActive) this.scrollRight();
        }, 5000);
      }, 5000);
    }
    
    this.showSharedWtemPopup = false;
    if(localStorage.getItem('instantOrder') !='2'){
      this.clearLocalStorage();
    }
      // ✅ Check shared cart link
  this.route.queryParams.subscribe(params => {
  // console.log('Query Params:', params);
  const cartKey = params['cartKey'];
  // console.log('Cart Key:', cartKey);

    if (cartKey) {
      this.sharedCartKey = cartKey; // Save globally for payload
            this.aspLoadingService.show();
      this.aspCartService.getCartData(cartKey).subscribe(
        (response: any) => {
          const items = response?.data?.items || [];
        this.aspLoadingService.hide();

          this.cartItems = items;

          // Optional: Save first item to session cart
          if (items.length > 0) {
            this.showSharedWtemPopup = true; 
            this.cartItems = items; 
            // const structuredCart = [{
            //   [items[0].rowKey]: {
            //     key: items[0].rowKey,
            //     partNumber: items[0].partNumber,
            //     name: items[0].name,
            //     brand: {
            //       key: items[0].brandKey || '',
            //       name: items[0].brandName || '',
            //       description: items[0].brandDescription || '',
            //     },
            //     cart_qty: items[0].cartQty || 1,
            //     category: items[0].category,
            //     customerBoughtCount: items[0].customerBoughtCount,
            //     deliveryStatus: items[0].deliveryStatus,
            //     deliveryTime: items[0].deliveryTime,
            //     description: items[0].description,
            //     discount: items[0].discount,
            //     discountType: items[0].discountType,
            //     hsn: items[0].hsn,
            //     imageUrl: items[0].imageUrl,
            //     itemId: items[0].itemId,
            //     itemSummary: {
            //       partNumber: items[0].partNumber,
            //       previouslyBought: items[0].previouslyBought,
            //       orderedCount: items[0].orderedCount,
            //       garageCount: items[0].garageCount
            //     },
            //     garageCount: items[0].garageCount,
            //     orderedCount: items[0].orderedCount,
            //     previouslyBought: items[0].previouslyBought,
            //     mrp: items[0].mrp,
            //     partType: items[0].partType,
            //     plannedSku: items[0].plannedSku,
            //     quantity: items[0].quantity,
            //     registrationNumber: items[0].registrationNumber,
            //     rowKey: items[0].rowKey,
            //     selectedFuel: items[0].selectedFuel,
            //     selectedMake: items[0].selectedMake,
            //     selectedModel: items[0].selectedModel,
            //     selectedYear: items[0].selectedYear,
            //     sellingPrice: items[0].sellingPrice,
            //     soldQuantity: items[0].soldQuantity,
            //     spareStocks: {
            //       partNumber: items[0].partNumber,
            //       quantity: items[0].quantity,
            //       mrp: items[0].mrp,
            //       sellingPrice: items[0].sellingPrice,
            //       discountType: items[0].discountType,
            //       discountAmount: items[0].discount
            //     },
            //     discountAmount: items[0].discount,
            //     subCategory: items[0].subCategory,
            //     tag: items[0].tag,
            //     unit: items[0].unit,
            //     unitType: items[0].unitType,
            //     variant: items[0].variant,
            //     variantKey: items[0].variantKey
            //   }
            // }];

            // localStorage.setItem('addedCart', JSON.stringify(structuredCart));
          }
           this.aspLoadingService.hide();
        },
        (error) => {
          console.error('❌ Error fetching shared cart data:', error);
                    this.aspLoadingService.hide();

        }
      );
    }
    });
    this.callBrandSpares();
    this.getCart();
     this.callServiceKits();
     this.marutiBrandSection();
     if (isFindMyCar) {
        setTimeout(() => {
          const el = document.getElementById('vehicle-form');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        }, 300);

        // localStorage.removeItem('isFindMyCar');
      }
  }

  get f() { return this.vehicleForm.controls; }

// handleScroll() {
//   const floatingBtn = document.getElementById('floatingBtn');
//   if (!floatingBtn) return;

//   const scrollContainer: HTMLElement | null = document.querySelector('.page-layout.blank.fullwidth');
//   const dashboard: HTMLElement | null = document.querySelector('.asp-dashboard');

//   if (!scrollContainer || !dashboard) return;

//   // Get relative position of dashboard inside scroll container
//   const dashboardOffsetTop = dashboard.offsetTop; // distance of dashboard from top
//   const scrollTop = scrollContainer.scrollTop;
//   const visibleHeight = scrollContainer.clientHeight;
//   const totalDashboardHeight = dashboard.scrollHeight;

//   // How much of dashboard has been scrolled past
//   const dashboardScrolled = scrollTop - dashboardOffsetTop;

//   // Prevent negative
//   if (dashboardScrolled < 0) {
//     floatingBtn.classList.remove('visible');
//     return;
//   }

//   const scrolledPercentage = (dashboardScrolled / (totalDashboardHeight - visibleHeight)) * 100;

  // console.log("Dashboard scrolled %:", scrolledPercentage);

//   if (scrolledPercentage >= 3) {
//     floatingBtn.classList.add('visible');
//   } else {
//     floatingBtn.classList.remove('visible');
//   }
// }
// ngAfterViewInit() {
//   const scrollContainer = document.querySelector('.page-layout.blank.fullwidth');
//   scrollContainer?.addEventListener('scroll', () => {
//     // console.log("scroll fired!")
//     this.handleScroll();
//   });
// }
handleScroll() {
  const floatingBtn = document.getElementById('floatingBtn');
  if (!floatingBtn) return;

  // ✅ Mobile → always visible instantly
  if (this.ismobile) {
    floatingBtn.classList.add('visible');
    return;
  }

  const scrollContainer = document.querySelector(
    '.page-layout.blank.fullwidth'
  ) as HTMLElement | null;

  if (!scrollContainer) return;

  const greetingDiv = document.querySelector(
    '.asp-dashboard__greeting'
  ) as HTMLElement | null;

  // ✅ If greeting doesn't exist → show immediately
  if (!greetingDiv) {
    floatingBtn.classList.add('visible');
    return;
  }

  const scrollTop = scrollContainer.scrollTop;
  const greetingBottom =
    greetingDiv.offsetTop + greetingDiv.offsetHeight;

  if (scrollTop >= greetingBottom) {
    floatingBtn.classList.add('visible');
  } else {
    floatingBtn.classList.remove('visible');
  }
}


ngAfterViewInit() {
    const scrollContainer = document.querySelector('.page-layout.blank.fullwidth');
  scrollContainer?.addEventListener('scroll', () => {
    // console.log("scroll fired!")
    this.handleScroll();
  });
      const navState: any = this.location.getState();
  if (navState?.triggerFunction) {
    this.loadInstantDetails();
  }
  if(localStorage.getItem('instantOrder')=='2'){
  this.loadInstantDetails();
  }
   const garageSelected =localStorage.getItem("garageKey");
    if (!garageSelected){
      const btn = document.getElementById('toolbarRef');
      btn?.click();
       this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: false },
        footer: { hidden: true },
        sidepanel: { hidden: true }
      }
    };
    }
}
  onSubmit() {
    this.submitted = true;
    if (this.vehicleForm.invalid) {
        return;
    }

    this.homeService.regDecode(this.f.regNo.value.replace(/\s/g, "")).subscribe(
      res => {
        // console.log("regdecorresponse",res)
        if(res['code']==200){
          this.loading = false;

           if (!res['data']?.variantKey && !res['data']?.variant) {
            localStorage.setItem("selectedMake", res['data']?.make);
            localStorage.setItem("selectedModel", res['data']?.model);
            localStorage.setItem("selectedYear", res['data']?.year);
            localStorage.setItem("rowKey", res['data']?.rowKey);
            localStorage.setItem("variant", res['data']?.variant);
            localStorage.setItem("imageUrlPath", res['data']?.imageUrlPath);
            localStorage.setItem("registrationNumber", res['data']?.registrationNumber);
            localStorage.setItem("vin", res['data']?.vin);
            this.goToVariant();
            return;
          }
          this.vehicleInfo = true; 
          this.isOpenFull=true;
          this.vehicleData = res['data'];
          localStorage.setItem("vehicleData", JSON.stringify(this.vehicleData));  
          localStorage.setItem("registrationNumber",this.vehicleData.registrationNumber.replace(/"/g, ''));  

        }else{
          this.toastr.error(res['data']['description'], 'Error');          
          this.loading = false;
          // this.goToVariant()
        }
      }
    );
  }
  // formatRegNo(value: string): string {
  //   // Remove all spaces and uppercase the value
  //   value = value.replace(/\s+/g, '').toUpperCase();

  //   // Insert spaces after the first 2 letters and the first 2 digits
  //   if (value.length > 2) {
  //       value = value.slice(0, 2) + ' ' + value.slice(2);
  //   }
  //   if (value.length > 5) {
  //       value = value.slice(0, 5) + ' ' + value.slice(5);
  //   }

  //   return value;
  // }
  formatRegNo(value: string): string {
    value = value.replace(/\s+/g, '').toUpperCase();
    if (value.length > 2) {
        value = value.slice(0, 2) + ' ' + value.slice(2);
    }
    if (value.length > 5) {
        value = value.slice(0, 5) + ' ' + value.slice(5);
    }
    if (value.length >8){
      value = value.slice(0,8) + ' ' + value.slice(8);
    }
    return value;
  }

  goToMake = () => {
    this.clearSelectedBrandCat();
    
    this.router.navigate(['make']);
  }
  goToVariant = () => {
    this.clearSelectedBrandCat();
    localStorage.setItem('isVariantFlow', '1');
    this.router.navigate(['variant']);
  }

  getPopularBrandsAndCategory = () => {
    this.loading = true;
    this.homeService.popularBrandsAndCategory().subscribe(
      res => {
        if(res && res['code']==200){
          this.loading = false;

          if(res['data']['brands'])
            this.brands = res['data']['brands'];

          if(res['data']['categories'])
            this.categories = res['data']['categories'];


        }else{    
          // this.closePopup();
          // this.router.navigate(['home']);  
          this.toastr.error(res['message'], 'Error');
          
          this.loading = false;
        }
      }
    )
  }

  goToAllBrands = () => {
    this.router.navigate(['all-brands']);
  }

  getAllCategories = () => {
    this.loading = true;
    this.homeService.getAllCategories().subscribe(
      res => {
        // console.log(res);
        if(res && res['code']==200){
          this.loading = false;
          this.veiwMoreCat = false;
          this.veiwLessCat = true;

          if(res['data']){
            this.allCategories = res['data'].sort((a, b) => a.priority - b.priority);
          }
          // console.log(this.allCategories);
        }else{    
          this.toastr.error(res['message'], 'Error');          
          this.loading = false;
        }
      }
    )
  }

  viewLessBrands = () => {    
    this.veiwMoreCat = true;
    this.veiwLessCat = false;
  }

  // brandSparesList = (brand:any, brandImg:any) => {
  //   this.clearSelectedBrandCat();

  //   localStorage.setItem("selectedBrand",  brand);   
  //   localStorage.setItem("selectedBrandImg",  brandImg);   
  //   localStorage.setItem("vehicleType",  'universal');   
  //   this.router.navigate(["brand-spares-list"]);
  // }

  // categorySparesList = (brand:any, brandImg:any) => {
  //   this.clearSelectedBrandCat();
      
  //   localStorage.setItem("selectedCategory",  brand);   
  //   localStorage.setItem("selectedCategoryImg",  brandImg);  
  //   localStorage.setItem("vehicleType",  'universal');    
  //   this.router.navigate(["category-spares-list"]);
  // }

  clearSelectedBrandCat(){
    if(localStorage.getItem("selectedBrand")){
      localStorage.removeItem('selectedBrand');
    }
    
    if(localStorage.getItem("selectedBrandImg")){
      localStorage.removeItem('selectedBrandImg');
    }
    
    if(localStorage.getItem("selectedCategory")){
      localStorage.removeItem('selectedCategory');
    }

    if(localStorage.getItem("selectedCategoryImg")){
      localStorage.removeItem('selectedCategoryImg');
    }
  }

  // onSubmit() {
  //   if(this.formData.partNumber){
  //     localStorage.removeItem('searchPartNumber');
  //     localStorage.setItem("searchPartNumber",  this.formData.partNumber);  
      
  //     this.clearSelectedBrandCat();
  //     this.router.navigate(['spare-parts-list']);
  //   }
  // }

  getTopMake() {
    let data = sessionStorage.getItem('spareVehicleDetails');   
    let vehicleDetails;
    
    if(data){
      this.loading = false;
      vehicleDetails = data;
      let res = JSON.parse(vehicleDetails); 
      Object.values(res.data).forEach(make => {
        if(make[0]['title']!='Universal' && this.makeList.length<=6){
          this.makeList.push(make[0]);
        }
      });
    }else{
      this.loading = true;
      this.aspMakeService.getMake().subscribe(
        result => {
          this.loading = false;
          // console.log(result);
          let vehicleDetails = JSON.stringify(result);          
          this.setVehicleDetails(vehicleDetails);
          
          let res = JSON.parse(vehicleDetails); 
          
          Object.values(res.data).forEach(make => {
            if(make[0]['title']!='Universal' && this.makeList.length<=6){
              this.makeList.push(make[0]);
            }
          });
        }
      )
    }
  }

  setVehicleDetails(data){
    sessionStorage.setItem('spareVehicleDetails', data); 
  }

  selectMake(make: any) {
    this.loading = true;
    if(localStorage.getItem('selectedMake') && localStorage.getItem('selectedModel') && localStorage.getItem('selectedYear') && localStorage.getItem('variant'))
      localStorage.setItem('newMake', make); 
    else
      localStorage.setItem('selectedMake', make);  

    this.router.navigate(['model']);

  }

  changeCar() {
    localStorage.removeItem('vehicleData');
    localStorage.removeItem('registrationNumber');
    localStorage.removeItem("isVariantFlow")
    localStorage.removeItem('vin');
    localStorage.removeItem("selectedSparesList");
    localStorage.removeItem("selectedSparesList");
    this.ngOnInit();
  }

  confirmCar() {
    let vehicleData = JSON.parse(localStorage.getItem('vehicleData'));


    localStorage.setItem('selectedMake', vehicleData['make']);
    localStorage.setItem('selectedModel', vehicleData['model']);
    localStorage.setItem('rowKey', vehicleData['rowKey']);
    localStorage.setItem('selectedYear', vehicleData['year']);
    
    localStorage.setItem('selectedFuel', vehicleData['fuel']);
    localStorage.setItem('fuelType', vehicleData['fuel']);
    localStorage.setItem('variant', vehicleData['variant']);
    localStorage.setItem('variantKey', vehicleData['variantKey']);
    this.sparesList(vehicleData['make']+' '+vehicleData['model'], 'allSpares')
    // this.router.navigate(['spare-parts-list']);
  }
  
  sparesList(name, type, imageUrl='',key=''){
    const isFindMyCar = localStorage.getItem("isFindMyCar");
    
    if (isFindMyCar !== "1") {
        localStorage.setItem("selectedSparesList",JSON.stringify({ name, type, imageUrl, key }));
    }
    localStorage.setItem("isDynamicPopup", "true");
    this.router.navigate(['spare-parts-list']);
    // if(type=='brandSpares'|| type=='categorySpares'){
    //   this.bottomSheet.open(AspDynamicPopupComponent, {
    //     panelClass: 'bottom-sheet-missmach'  
    //   });
    // }
  }
  
  private clearLocalStorage(){
    sessionStorage.removeItem('sparePartsDetails');
    localStorage.removeItem('vehicleType');
    localStorage.removeItem('newMake');
    localStorage.removeItem('newModel');
    localStorage.removeItem('newYear');
    localStorage.removeItem('newVariant');
    localStorage.removeItem('newVariantKey');
    localStorage.removeItem('newRowKey');
    localStorage.removeItem('isShippingCharges');
    localStorage.removeItem('prepayUpiDiscount');
    // localStorage.removeItem('vehicleData');
    localStorage.removeItem('selectedModel');
    localStorage.removeItem('selectedYear');
    localStorage.removeItem('selectedFuel');
    localStorage.removeItem('variant');
    localStorage.removeItem('selectedFuel');
    localStorage.removeItem('variantKey');
    localStorage.removeItem('rowKey');

    if(localStorage.getItem("isFindMyCar")!='1'){
      localStorage.removeItem('selectedSparesList');
    }
    localStorage.removeItem('preSearchValue');
  };
  redirectToVehicleForm() {
    this.router.navigate(['vehicle']);
  }

  toggleSearch() {
    this.isInputVisible = !this.isInputVisible;
    if (this.isInputVisible) {
      setTimeout(() => {
        const input = document.querySelector('.SearchInput') as HTMLInputElement;
        if (input) {
          input.focus();
        }
      }, 0);
    }
  }

  clearSearch(event: Event) {
    this.searchText = '';
   event.stopPropagation();
    // this.searchText = ''; // Clear the search text
    this.isInputVisible = false; // Hide the input field if needed
    this.filterSuggestions();
  }

    
  filterSuggestions() {
    if (this.searchText && this.searchText.length >= 3) {
        let rowKey = localStorage.getItem('rowKey');
        
        let universal = false;
        let variantKey = localStorage.getItem('variantKey');
        
        this.searchSuggestionService.getSearchSuggestions(rowKey, this.searchText, universal, variantKey).subscribe(
            result => {


                this.suggestions = [];
                if (result['data'].partNumbers && result['data'].partNumbers.length > 0)
                    this.suggestions.push(...result['data'].partNumbers.map((value: string) => ({ value, type: 'partNumber' })));
                if (result['data'].brands && result['data'].brands.length > 0)
                    this.suggestions.push(...result['data'].brands.map((value: string) => ({ value, type: 'brand' })));
                if (result['data'].categories && result['data'].categories.length > 0)
                    this.suggestions.push(...result['data'].categories.map((value: string) => ({ value, type: 'category' })));
                if (result['data'].partNames && result['data'].partNames.length > 0)
                    this.suggestions.push(...result['data'].partNames.map((value: string) => ({ value, type: 'partName' })));


                // Sort suggestions based on relevance
                this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);

            }
        );
    } else {
        this.suggestions = [];
    }
}

selectSuggestion(suggestion: { value: string, type: string }) {
  this.selectedSuggestions.add(suggestion.value);
  this.searchText = '';
  this.filterSuggestions();
  this.isInputVisible = false;
  if(localStorage.getItem("isFindMyCar")!='1'){
    if (suggestion.type === 'partNumber') {
        this.clearLocalStorage();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['product-details/part-number/' + suggestion.value]);
        });
    } else if (suggestion.type === 'category') {
        this.clearLocalStorage();
        localStorage.setItem('selectedSparesList', JSON.stringify({"name": suggestion.value, "type": "categorySpares", "imageUrl": ""}));
        
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/spare-parts-list']);
        });
    } else if (suggestion.type === 'brand') {
        this.clearLocalStorage();
        localStorage.setItem('selectedSparesList', JSON.stringify({"name": suggestion.value, "type": "brandSpares", "imageUrl": ""}));
        
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/spare-parts-list']);
        });
    }else {          
      this.clearLocalStorage();  
        localStorage.setItem("preSearchValue", suggestion.value);
        localStorage.setItem('selectedSparesList', JSON.stringify({"name": suggestion.value, "type": "allSpares", "imageUrl": ""}));
        
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['/spare-parts-list']);
        });
    }
  }
}

sortSuggestionsByRelevance(suggestions: string[], searchText: string): string[] {
  return suggestions?.sort((a, b) => {
      const relevanceA = this.getRelevance(a, searchText);
      const relevanceB = this.getRelevance(b, searchText);
      return relevanceB - relevanceA; // Higher relevance comes first
  });
}
getRelevance(suggestion: string, searchText: string): number {
  if (suggestion?.toString().toLowerCase() === searchText?.toLowerCase()) {
      return 3; // Exact match
  } else if (suggestion?.toString().toLowerCase().startsWith(searchText?.toLowerCase())) {
      return 2; // Starts with match
  } else if (suggestion?.toString().toLowerCase().includes(searchText?.toLowerCase())) {
      return 1; // Contains match
  } else {
      return 0; // No match
  }
}
isFirstSuggestion(suggestion: string, index: number): boolean {
  // Check if it's the first suggestion and if it matches preSearchValue
  let preSearchValue=localStorage.getItem('preSearchValue');
  return index === 0 && preSearchValue === suggestion['value'];
}

getHighlightedText(text: any, search: any): string {
  if (typeof text !== 'string' || typeof search !== 'string') {
      return text;
  }

  if (!search) {
      return text; 
  }

  const parts = text.split(new RegExp(`(${search})`, 'gi'));
  return parts.map(part => part.toLowerCase() === search.toLowerCase()
      ? `<span class="highlight">${part}</span>`
      : part
  ).join('');
}


// @ViewChild('dynamicContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
// loadorderdetails(): void {
//   this.container.clear();
//   const factory = this.resolver.resolveComponentFactory(SpareKitSidebarComponent);
//   const componentRef = this.container.createComponent(factory);
//   const componentInstance = componentRef.instance as SpareKitSidebarComponent;
//   componentInstance.isVisible = true;  
//   componentInstance.isConfirmationSidebarOpen = false;
// }
scrollRight() {
  const container = document.querySelector('.banners-container'); 
  if (container) {
      container.scrollBy({ left: 436, behavior: 'smooth' });
  } else {
      console.error('Element not found: .banners-container');
  }
}
scrollLeft() {
  const container = document.querySelector('.banners-container');
  if (container) {
      container.scrollBy({ left: -436, behavior: 'smooth' });
  } else {
      console.error('Element not found: .banners-container');
  }
}
// Stop auto-scroll on user interaction (optional)
stopAutoScroll() {
  this.autoScrollActive = false;
  if (this.autoScrollInterval) {
    clearInterval(this.autoScrollInterval);
  }
}

categoryBanner(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Body","type":"categorySpares","imageUrl":"","key":""}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Body":["Bumper"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Bumper"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
brandBanner(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Bosch","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/brand/bosch_logo.png","key":"ebdeb4a88164633bb71c1d9a0d647f7c"}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Windscreen Cleaning System":["Wiper Blade"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Wiper Blade"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
Purolator_Filters()
{
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Purolator","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/prodimages/purolator.png","key":"3484ac680af6165afc8b35e3736cab67"}))
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Cabin Filter","Filter Set","Fuel Filter","Oil Filter","Air Filter"],"brand":[]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("selectedCategory",JSON.stringify({"Filters":["Cabin Filter","Filter Set","Fuel Filter","Oil Filter","Air Filter"]}));
  this.router.navigate(['spare-parts-list']);
}
Floron_AC_Gas(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Floron","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/brand/floron.png","key":"1be1b57c092bc60a73926d12cfb96f3f"}))
  this.router.navigate(['spare-parts-list']);
}
Hella_Coolant_Premium1(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Hella","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/brand/hella_icon.png","key":"cc6dd726ba70ac8caafc8f22d82758cd"}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Engine Cooling System":["Coolant"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Coolant"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
Maruti_Suzuki_Clutch_Release()
{
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Maruti Suzuki","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/marutisuzuki.png","key":"3dd5a0e87558f673fa4caa008d3ccafa"}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Clutch System":["Clutch Release Bearing"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Clutch Release Bearing"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
NGK_Spark_Plugs_1(){
  
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"NGK","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/brand/ngk.png","key":"1d530dd95b641c9bf3254f7d66c6299e"}))
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Spark Plug"],"brand":[]}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Ignition and Glowplug System":["Spark Plug"]}));
  localStorage.setItem("selectedBrands","[]");
  this.router.navigate(['spare-parts-list']);
}
TVS_Girling_Brake_Pads_1()
{
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"TVS Girling","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/assets/img/brand/Tvsgirling.png","key":"91f95eb3bd81f5aceeee9b9c440d289d"}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Brake System":["Brake Pads"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Brake Pads"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
Zip_AC_Filters(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Zip","type":"brandSpares","imageUrl":"https://cube.getpitstop.com/prodimages/zip.png","key":"99010775ee7376912dc709e916fce456"}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Filters":["Cabin Filter"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Cabin Filter"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
Head_Lamp_1(){
  localStorage.setItem("selectedSparesList", JSON.stringify({"name":"Lighting","type":"categorySpares","imageUrl":"","key":""}));
  localStorage.setItem("selectedCategory",JSON.stringify({"Lighting":["Headlight"]}));
  localStorage.setItem("selectedBrands","[]");
  localStorage.setItem("filterParams",JSON.stringify({"subCategory":["Headlight"],"brand":[]}))
  this.router.navigate(['spare-parts-list']);
}
shareDetails(){
  const message = `🚘 Vehicle Information \n\nDear Customer,\n\nHere are the details of your car with Registration Number *${this.vehicleData.registrationNumber}*\n\n 1️⃣ *Make:* ${this.vehicleData.make} \n 2️⃣ *Model:*  ${this.vehicleData.model}  \n 3️⃣ *Variant:*  ${this.vehicleData.variant}  \n 4️⃣ *MFG Year:* ${this.vehicleData.year}  \n 5️⃣ *Fuel Type:* ${this.vehicleData.fuel} \n 6️⃣ *VIN*: ${this.vehicleData.vin}  \n\n Regards, \n *Autoverse Mobility Pvt. Ltd.*`;
  // console.log("message",message)
  const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
}


// Google Analytics
onButtonClick(){
  this.googleAnalyticsService.triggerEvent('button_click', {
    category: 'User Interaction - Testing.',
    label: 'Click Me Button',
    value: 1,
  });
}
// End Google Analytics



// addSharedCartToLocalCart() {
//   this.aspLoadingService.show();
//   this.showSharedWtemPopup = true;

//   // const cartKey = localStorage.getItem('cartKey') || '';
//     const cartKey = this.sharedCartKey


//   if (this.cartItems && this.cartItems.length > 0) {
//     const structuredCartObject = {};
//     console.log("this.cartItems-----",this.cartItems);
//     this.cartItems.forEach(item => {
//       const key = item.partKey && item.partKey.trim() ? item.partKey : item.itemId;

//       structuredCartObject[key] = {
//         key: key,
//         partNumber: item.partNumber,
//         name: item.name,
//         brand: {
//           key: item.brandKey || '',
//           name: item.brandName || '',
//           description: item.brandDescription || '',
//         },
//         cart_qty: item.cartQty || 1,
//         category: item.category,
//         customerBoughtCount: item.customerBoughtCount,
//         deliveryStatus: item.deliveryStatus,
//         deliveryTime: item.deliveryTime,
//         description: item.description,
//         discount: item.discount,
//         discountType: item.discountType,
//         hsn: item.hsn,
//         imageUrl: item.imageUrl,
//         itemId: item.itemId,
//         itemSummary: {
//           partNumber: item.partNumber,
//           previouslyBought: item.previouslyBought,
//           orderedCount: item.orderedCount,
//           garageCount: item.garageCount
//         },
//         garageCount: item.garageCount,
//         orderedCount: item.orderedCount,
//         previouslyBought: item.previouslyBought,
//         mrp: item.mrp,
//         partType: item.partType,
//         plannedSku: item.plannedSku,
//         quantity: item.quantity,
//         registrationNumber: item.registrationNumber,
//         rowKey: item.rowKey,
//         selectedFuel: item.selectedFuel,
//         selectedMake: item.selectedMake,
//         selectedModel: item.selectedModel,
//         selectedYear: item.selectedYear,
//         sellingPrice: item.sellingPrice,
//         soldQuantity: item.soldQuantity,
//         spareStocks: {
//           partNumber: item.partNumber,
//           quantity: item.quantity,
//           mrp: item.mrp,
//           sellingPrice: item.sellingPrice,
//           discountType: item.discountType,
//           discountAmount: item.discount
//         },
//         discountAmount: item.discount,
//         subCategory: item.subCategory,
//         tag: item.tag,
//         unit: item.unit,
//         unitType: item.unitType,
//         variant: item.variant,
//         variantKey: item.variantKey
//       };
//     });

// const structuredCart = [structuredCartObject];

//     // ✅ Store in sessionStorage here
//     localStorage.setItem('addedCart', JSON.stringify(structuredCart));
//   }

//   // Update cart details via API
//   const payload = { cartKey };

//   this.aspCartService.updateCartDetails(payload).subscribe(
//     (response: any) => {
//       console.log('✅ Cart updated successfully:', response);
//       this.aspLoadingService.hide();
//       this.showSharedWtemPopup = false;
//       this.router.navigate(['/cart']);
//     },
//     error => {
//       console.error('❌ Failed to update cart:', error);
//       this.aspLoadingService.hide();
//     }
//   );
// }



closeSharedWtemPopup() {
  // const cartKey = localStorage.getItem('cartKey') || '';
    const cartKey = this.sharedCartKey

  const payload = { cartKey };

  this.aspCartService.updateCartDetails(payload).subscribe(
    (response: any) => {
      // console.log('✅ Cart updated successfully on cancel:', response);
    },
    error => {
      console.error('❌ Failed to update cart on cancel:', error);
    }
  );

  this.showSharedWtemPopup = false;
}

// shareCartViaWhatsApp() {
//         this.aspLoadingService.show();
//   const garageName = (localStorage.getItem('spareSelectedGarageName') || 'Our Garage').trim();
//   const vehicleName = localStorage.getItem('selectedVehicleName') || 'Vehicle';
//   const garageKey = localStorage.getItem('garageKey') || '';
//   const userKey = localStorage.getItem('spareUserKey') || '';
//   const registrationNumber = localStorage.getItem('selectedRegistrationNumber') || '';

//   if (!this.cartList || this.cartList.length === 0) {
//     console.warn('Cart is empty.');
//     return;
//   }

//   const payload = this.cartList.map(item => ({
//     partKey: item.part_key || item.partKey || '',
//     rowKey: item.row_key || item.rowKey || '',
//     partNumber: item.partNumber || '',
//     name: item.name || '',
//     brandKey: item.brandKey || '',
//     brandName: item.brandName || '',
//     brandDescription: item.brandDescription || '',
//     cartQty: item.cart_qty || item.cartQty || 1,
//     category: item.category || '',
//     customerBoughtCount: item.customerBoughtCount || 0,
//     deliveryStatus: item.deliveryStatus || '',
//     deliveryTime: item.deliveryTime || '',
//     description: item.description || null,
//     discount: item.discount || 0,
//     discountType: item.discountType || null,
//     hsn: item.hsn || '',
//     imageUrl: item.imageUrl || '',
//     itemId: item.itemId || '',
//     garageCount: item.garageCount || 0,
//     orderedCount: item.orderedCount || 0,
//     previouslyBought: item.previouslyBought || false,
//     mrp: item.mrp || 0,
//     partType: item.partType || '',
//     plannedSku: item.plannedSku || 0,
//     quantity: item.quantity || 0,
//     registrationNumber: registrationNumber,
//     selectedFuel: item.selectedFuel || '',
//     selectedMake: item.selectedMake || '',
//     selectedModel: item.selectedModel || '',
//     selectedYear: item.selectedYear || '',
//     sellingPrice: item.sellingPrice || 0,
//     soldQuantity: item.soldQuantity || 0,
//     discountAmount: item.discountAmount || 0,
//     subCategory: item.subCategory || '',
//     tag: item.tag || '',
//     unit: item.unit || 0,
//     unitType: item.unitType || '',
//     variant: item.variant || '',
//     variantKey: item.variantKey || '',
//     garageKey: garageKey,
//     userKey: userKey
//   }));
// this.aspLoadingService.show();
// this.aspCartService.createCart(payload).subscribe(
//     (response: any) => {
//       this.aspLoadingService.hide();
//       const cartKey = response?.data?.[0]?.cartKey;
//       if (!cartKey) {
//         console.error('Cart key missing in response');
//         return;
//       }
      
//   const shareCartUrl = `${GlobalVariable.AUTOVERSE_WEB}/cart?cartKey=${cartKey}`;

//       const message =
//         `Hello ${garageName}! 👋\n\n` +
//         `🚗🔧 Find the Perfect ${vehicleName} Parts List!\n\n` +
//         `Upgrade your customer's rides with precision.\n\n` +
//         `Tap to explore now 👉 🛠\n${shareCartUrl}`;

//       const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
//       window.open(whatsappUrl, '_blank');
//     },
//     error => {
//       console.error('Error creating cart:', error);
//     }
//   );

// }
openMake(){
  this.isOpenMake=true;
}
  @ViewChild('intstantorder', { read: ViewContainerRef }) container!: ViewContainerRef;
  loadInstantDetails() {
    //  this.container.clear();
    
  this.magicPopup=false;
    const factory = this.resolver.resolveComponentFactory(AspInstantOrderComponent);
    const componentRef = this.container.createComponent(factory);

    const componentBInstance = componentRef.instance as AspInstantOrderComponent;

           // Toggle the form sidebar (instead of the confirmation sidebar)
        if(localStorage.getItem('instantOrder')  && localStorage.getItem('instantOrder') == '2'){
          // this.loadorderdetails();
    
        componentBInstance.closeDetails(true);  
           componentBInstance.openSidebar(true);
      }
      else{
        componentBInstance.closeDetails(false); 
        componentBInstance.openSidebar(true);
        localStorage.removeItem('carNumber');
      }
  }

  close(){
    this.magicPopup=false;
    const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;

    // To hide
    cartCountEl.style.display = 'block';
  }
  // loadrequest() {
  //   // alert("load request got hit");
  //   const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
  //   const componentRef = this.container.createComponent(factory);
  //   const instance = componentRef.instance as AspInstantRequestComponent;
  //   // instance.loadInstantDetails();
  //    instance.openSidebar(true);
  // }
    @ViewChild('orderlistContainer', { read: ViewContainerRef }) container1!: ViewContainerRef;
  loadrequest() {

    // If insurance NOT loaded → load first
    if (!this.insurance || this.insurance.length === 0) {
      this.getInsurance();
      return;
    }

    // If insurance exists and not step-2 → open insurance sidebar
    if (this.insurance.length > 0 && localStorage.getItem('instantOrder') !== '2') {

      this.isInsurance = true;
      this.openEdit   = false;
      this.selectedType    = '';
      this.selectedCompany = '';
      this.showError  = false;
      this.showError1 = false;

      return;
    }

    // Else open instant request
    this.openInstantSidebar();
  }

// loadrequest() {

//   // ✅ If insurance data not loaded yet – fetch first
//   if (!this.insurance || this.insurance.length === 0) {
//     this.getInsurance();   // 👈 very important
//     return;
//   }

//   // 🛡️ If insurance flow is required – open insurance sidebar
//   if (this.insurance.length > 0 && localStorage.getItem('instantOrder') !== '2') {

//     this.isInsurance = true;
//     this.openEdit   = false;

//     this.selectedType = '';
//     this.selectedCompany = '';

//     this.showError  = false;
//     this.showError1 = false;

//     return;   // ⛔ stop here
//   }

//   // ✅ Otherwise open Instant Request sidebar
//   this.openInstantSidebar();
// }

  // getInsurance(){
  //     this.aspMyRequestService.getInsurance().subscribe(
  //       result => {
          // console.log("result",result);
  //         this.insurance=result['data']
  //             const navState: any = this.location.getState();
  //     if (navState?.triggerFunction) {
  //       this.loadrequest();
  //     }
  //     if(localStorage.getItem('instantOrder')=='2'){
  //     this.loadrequest();
  //     }
  //       })
    
  // }

  getInsurance() {
  this.aspMyRequestService.getInsurance().subscribe(result => {

    this.insurance = result['data'] || [];

    // ✅ ALWAYS re-trigger open after API completes
    this.loadrequest();

  });
}

  loadOrderList() {
    this.container1.clear();
    const factory = this.resolver.resolveComponentFactory(AspOrderListComponent);
    const componentRef = this.container1.createComponent(factory);
    const instance = componentRef.instance as AspOrderListComponent;
    this.router.navigate(['/order-list']);
    instance.ngOnInit();
  }
  
  loadMakePayment(){
  this.router.navigate(['/payment-collection'])
  }
  // ================below is new-home-page-api-function===============
  callGarageMetrics() {
    this.aspLoadingService.show();
    const garageKey   = localStorage.getItem('garageKey');
    const userKey     = localStorage.getItem('spareUserKey');
    const filterWith  = '';
     this.aspLoadingService.show();
    this.homeService
      .getGarageMetrics(garageKey, userKey, filterWith)
      .subscribe(
        (res: any) => {
          
          // console.log('Garage Metrics Response:', res);

          if(res?.code == 200 && res?.data){

            const data = res.data;

            // Snapshot
            this.garageName    = data.garageName;
            this.totalSavings = data.totalSavings;
            this.totalPurchasePercentage = data.totalPurchasePercentage;
            this.totalSavingsPercentage = data.totalSavingsPercentage;
            this.totalPurchase = data.totalPurchase;
            this.totalOrders  = data.totalOrders;
            this.oesPercentage = data.oesPercentage;
            this.outStandings = data.outStandings;
            this.month = data.month;
            // Lists
            this.recentOrdersList = data.recentOrdersList || [];
            this.requestProgressList = data.requestProgressList || [];

            // Todo
            this.pendingQuoteApprove = data?.toDoList?.pendingQuoteApprove || 0;
            this.totalDues = data?.toDoList?.totalDues || 0;
            this.pendingQuoteApprove =  data?.toDoList?.pendingQuoteApprove || 0;
          // header count = same as pending quotes for now
          this.pendingCount = this.pendingQuoteApprove;

          }
          this.aspLoadingService.hide();
        },
        (err) => {
          console.error('Garage Metrics Error:', err);
          this.aspLoadingService.hide();
        }
      );
  }
// =====order-details-navigation=============
  @ViewChild('intstantorder', { read: ViewContainerRef }) containers!: ViewContainerRef;
  loadorderdetails(orderKey) {
      
      this.orderKey = orderKey;
      const factory = this.resolver.resolveComponentFactory(AspOrderDetailsComponent);
      const componentRef = this.container.createComponent(factory);
  
      // Access the instance and call the method
      const componentBInstance = componentRef.instance as AspOrderDetailsComponent;
      componentBInstance.closeSidebar(true);
      componentBInstance.getOrderDetails(orderKey);
  
    }
// ============request-details-navigation===========
  navigateToDetails(id: string) {
    this.router.navigate(
      ['/request-details'],
      { queryParams: { id: id } }
    );
  }
  // getOrderStatusClass(status: string): string {
  //   if (!status) return '';

  //   const s = status.toLowerCase();

  //   switch (s) {
  //     case 'created':
  //       return '🆕 created';
  //     case 'confirmed':
  //       return '✅ confirmed';
  //     case 'packed':
  //       return '📦 packed';
  //     case 'on the way':
  //       return '🚚 on-the-way';
  //     case 'delivered':
  //       return '📍 delivered';
  //     default:
  //       return '';
  //   }
  // }
    getOrderStatusIcon(status: string): string {
    if (!status) return '';

    const s = status.toLowerCase();

    switch (s) {
      case 'created':
        return '🆕';
      case 'confirmed':
        return '✅';
      case 'packed':
        return '📦';
      case 'on the way':
        return '🚚';
      case 'delivered':
        return '📍';
      default:
        return '';
    }
  }

  getOrderStatusClass(status: string): string {
    if (!status) return '';

    const s = status.toLowerCase();

    switch (s) {
      case 'created':
        return 'created';
      case 'confirmed':
        return 'confirmed';
      case 'packed':
        return 'packed';
      case 'on the way':
        return 'on-the-way';
      case 'delivered':
        return 'delivered';
      default:
        return '';
    }
  }


  // getOrderStatusText(status: string): string {

  //   if (!status) return 'Order placed';

  //   const s = status.toLowerCase();

  //   if (s === 'packed') {
  //     return '📦 Parts packed';
  //   }
  //   if (s === 'in transit' || s === 'shipped') {
  //     return '🚚 Parts in transit';
  //   }
  //   if (s === 'delivered') {
  //     return '✅ Parts delivered';
  //   }
  //   if (s === 'cancelled') {
  //     return '❌ Order cancelled';
  //   }

  //   return '🛠 Parts sourced';
  // }
    getOrderStatusText(status: string): string {

    if (!status) return 'Order placed';

    const s = status.toLowerCase();

    if (s === 'packed') {
      return 'Parts packed';
    }

    // ✅ API gives "On The Way"
    if (s === 'on the way' || s === 'in transit' || s === 'shipped') {
      return 'Parts in transit';
    }

    // ✅ API gives "Confirmed"
    if (s === 'confirmed') {
      return 'Parts confirmed';
    }

    if (s === 'delivered') {
      return 'Parts delivered';
    }

    if (s === 'cancelled') {
      return 'Order cancelled';
    }

    // fallback for unexpected values
    return status;
  }


  // =============status showing in request tab of home page============
  getStatusMessage(statusDetails: { [key: string]: number } | undefined): string {

    if (!statusDetails) return '⏳ Requested';

    if (statusDetails['4'] || statusDetails['10']) {
      return '📦 Order Created';
    } else if (statusDetails['9']) {
      return '✅ Quote Approved';
    } else if (statusDetails['8']) {
      return '💬 Quote Received';
    } else if (statusDetails['1']) {
      return '⏳ Requested';
    } else if (statusDetails['0']) {
      return '❌ Cancelled';
    } else {
      return '⏳ Requested';
    }
  }

  buildStatusDetails(status: number) {
    if (status === undefined || status === null) return undefined;

    return {
      [status.toString()]: 1
    };
  }
  getStatusClass(status: number | undefined): string {
    switch (status) {
      case 4:
      case 10:
        return 'order-created';
      case 9:
        return 'quote-approved';
      case 8:
        return 'quote-received';
      case 1:
        return 'requested';
      case 0:
        return 'cancelled';
      default:
        return 'requested';
    }
  }

  // =================my-request-page-with status===============?
  goToRequestsByStatus(status: number) {
    this.router.navigate(['/my-request'], { queryParams: { status: status } });
  }
  getRequestStatusText(status: number): string {

    if (status === undefined || status === null) {
      return 'Requested';
    }

    switch (status) {

      case 4:
      case 10:
        return 'Order Created';

      case 9:
        return 'Quote Approved';

      case 8:
        return 'Quote Pending Approval';

      case 1:
        return 'Quote Requested';

      case 0:
        return 'Cancelled';

      default:
        return 'Quote Requested';
    }
  }
  // ==========giving space  after, in part names===========
  formatItemNames(itemNames: string): string {
    return itemNames ? itemNames.split(',').join(', ') : '';
  }
skip() {

  this.isInsurance = false;
  this.openEdit = false;

  localStorage.removeItem("isInsurance");
  localStorage.removeItem('insuranceGarageKey');

  this.openInstantSidebar();  // ✅ Direct open
}
continue(): void {

  if (!this.selectedType) {
    this.showError = true;
    return;
  }

  if (this.selectedType === 'insurance' && !this.selectedCompany) {
    this.showError1 = true;
    return;
  }

  this.isInsurance = false;

  const type = this.selectedType === 'insurance';
  localStorage.setItem("isInsurance", String(type));
  localStorage.setItem('insuranceGarageKey', this.selectedCompany);

  this.openInstantSidebar();   // ✅ Open the main sidebar now
}
openInstantSidebar() {
  const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
  const componentRef = this.containers.createComponent(factory);
  const instance = componentRef.instance as AspInstantRequestComponent;

  if (localStorage.getItem('instantOrder') === '2') {
    instance.closeDetails(true);
    instance.openSidebar(true);
  } else {
    instance.closeDetails(false);
    instance.openSidebar(true);
    localStorage.removeItem('carNumber');
  }
}
goBackList(){
    this.isInsurance=false;
    this.selectedType='';
    this.selectedCompany = '';
    this.insuranceGarageId='';
    this.showError = false;
    this.showError1 = false;
    this.openEdit=false;
}
  selectType(type: string): void {
    this.selectedType = type;
    this.showError = false;   
    if (type === 'insurance') {
      if(this.insurance.length<=1){
        this.selectCompany(this.insurance[0])
      }else{
      this.filteredList = [...this.insurance]; // show all initially
      }
    } else {
      this.selectedCompany = null;
      this.searchText = '';
    }
  }
     selectCompany(company: string): void {
      
      this.showError1 = false;   
      this.selectedCompany = company['insuranceGarageKey'];
      this.insuranceGarageId=company['insuranceGarageId'];
      // console.log('Selected company:', company);
    }
  get isContinueActive(): boolean {
  // active if non-insurance, or insurance + company selected
  return (
    this.selectedType === 'non-insurance' ||
    (this.selectedType === 'insurance' && !!this.selectedCompany)
  );
}
showPopup(){
  this.showPopupinfo=true;
}
closePopup(){
  this.showPopupinfo=false;
}
toggleEditMenu(index: number, event: Event) {
  event.stopPropagation();
  this.openEditIndex = this.openEditIndex === index ? null : index;
}
  onSearchChange(): void {
    const query = this.searchText.trim().toLowerCase();
    if (!query) {
      this.filteredList = [...this.insurance];
    } else {
      this.filteredList = this.insurance.filter(c =>
        c.insuranceGarageName.toLowerCase().includes(query)
      );
    }
  }


setGreeting(): void {
  const hour = new Date().getHours(); // 0–23

  if (hour >= 5 && hour < 12) {
    this.greeting = 'Good Morning';
  } else if (hour >= 12 && hour < 17) {
    this.greeting = 'Good Afternoon';
  } else if (hour >= 17 && hour < 21) {
    this.greeting = 'Good Evening';
  } else {
    this.greeting = 'Greetings from Autoverse';
  }
}
get hasDashboardData(): boolean {
  return (
    (this.pendingCount ?? 0) > 0 ||
    (this.totalDues ?? 0) > 0 ||
    (this.totalSavings ?? 0) > 0 ||
    (this.totalPurchase ?? 0) > 0 ||
    (this.totalOrders ?? 0) > 0 ||
    (this.oesPercentage ?? 0) > 0 ||
    (this.recentOrdersList?.length ?? 0) > 0 ||
    (this.requestProgressList?.length ?? 0) > 0
  );
}
toggleProduct(id: number) {
  this.expandedProduct = this.expandedProduct === id ? null : id;
}
// callBrandSpares(page: number = 0, size: number = 20, brand: string = 'Autoverse') {
//   this.loading = true;
//   const garageKey = localStorage.getItem('garageKey');

//   this.aspLoadingService.show();

//   this.homeService.getBrandSpares(page, size, brand).subscribe(
//     (res: any) => {
//       console.log('Brand Spares Response:', res);

//       if (res?.code === 200 && res?.data) {
//          this.loading = false;
//         const spares = res.data?.spares || [];
//         const spareStocks: SpareStock[] = res.data?.spareStocks || [];

//         // Map partNumber to stock for faster lookup
//         const stockMap = new Map(spareStocks.map(stock => [stock.partNumber, stock]));

//         // Enrich spares with stock info
//         this.brandSparesList = spares.map(spare => {
//           const stock = stockMap.get(spare.partNumber as string); // cast partNumber if needed
//           return {
//             ...spare,
//             mrp: stock?.mrp ?? 0,
//             sellingPrice: stock?.sellingPrice ?? 0,
//             discountType: stock?.discountType ?? null,
//             discountAmount: stock?.discountAmount ?? 0,
//             quantity: stock?.quantity ?? 0
//           };
//         });

//         this.totalSparesCount = res.data.totalItems || 0;

//         console.log('Brand Spares List with Stock Info:', this.brandSparesList);
//       }

//       this.aspLoadingService.hide(); // hide loader
//     },
//     (err) => {
//       console.error('Brand Spares Error:', err);
//       this.aspLoadingService.hide(); // hide loader even on error
//     }
//   );
// }
callBrandSpares(
  page: number = 0,
  size: number = 20,
  brand: string = 'Autoverse'
) {
  this.loading = true;
  const garageKey = localStorage.getItem('garageKey');

  this.aspLoadingService.show();

  this.homeService.getBrandSpares(page, size, brand).subscribe(
    (res: any) => {
      console.log('Brand Spares Response:', res);

      if (res?.code === 200 && res?.data) {

        const spares = res.data?.spares || [];
        const spareStocks: SpareStock[] = res.data?.spareStocks || [];

        // 🔹 Create Map for fast lookup
        const stockMap = new Map(
          spareStocks.map(stock => [stock.partNumber, stock])
        );

        // 🔹 Merge & calculate discount
        this.brandSparesList = spares.map(spare => {

          const stock = stockMap.get(spare.partNumber as string);

          const mrp = stock?.mrp ?? 0;
          const sellingPrice = stock?.sellingPrice ?? 0;

          let discountPercent = 0;

          if (mrp > 0 && sellingPrice < mrp) {
            discountPercent = Math.round(
              ((mrp - sellingPrice) / mrp) * 100
            );
          }

          return {
            ...spare,
            mrp: mrp,
            sellingPrice: sellingPrice,
            discount: discountPercent,   // 👈 THIS is what UI needs
            discountType: stock?.discountType ?? null,
            discountAmount: stock?.discountAmount ?? 0,
            quantity: stock?.quantity ?? 0
          };
        });

        this.totalSparesCount = res.data.totalItems || 0;
        this.loading = false;

        console.log(
          'Brand Spares List with Stock Info:',
          this.brandSparesList
        );
      }

      this.aspLoadingService.hide();
    },
    (err) => {
      console.error('Brand Spares Error:', err);
      this.loading = false;
      this.aspLoadingService.hide();
    }
  );
}

openAutoverseStore() {
  // Passing Autoverse as a category/brand type
  this.sparesListNew('Autoverse', 'brandSpares');
}
sparesListNew(name, type, imageUrl = '', key = '') {
  const isFindMyCar = localStorage.getItem("isFindMyCar");
  
  if (isFindMyCar !== "1") {
    localStorage.setItem(
      "selectedSparesList",
      JSON.stringify({ name, type, imageUrl, key })
    );
  }

  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
openWhatsApp() {
    const encodedMessage = encodeURIComponent(this.whatsAppMessage);
    const url = `https://web.whatsapp.com/send?phone=${this.whatsAppNumber}&text=${encodedMessage}`;
    window.open(url, '_blank');
  }
  removeItem(count, item){ 
    this.addedCart = [];    
    let data;
    
    data = JSON.parse(localStorage.getItem('addedCart'))[0];
    if(count>1){
      let countval = count-1;
      data[item].cart_qty = countval;

      if(this.vehicleType=='universal'){
        data[item].type = 'universal';
      }

      this.addedCart[0] = data;
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      this.getCart();
    }else{
      this.deleteItem(item);
      this.toastr.error(data[item].name+' removed from cart', 'Cart Item');
    }
  }

  deleteItem(item){
    this.newData = {};
    let cartData;

    cartData = JSON.parse(localStorage.getItem('addedCart'));
    Object.values(cartData[0]).forEach(cart => { 
      if(cart['key']!=item) {
        this.newData[cart['key']] = cart;
      }
    });
    
    this.addedCart[0] = this.newData;
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    this.getCart();
    // console.log(this.addedCart);
    
  }

  addItem(count, item){
    let countval = count+1;
    
    // this.addCart(item,countval);
    this.addedCart = [];
    let data;
    
    // data = JSON.parse(localStorage.getItem('addedCart'))[0];
    // if(countval<=data[item].spareStocks.quantity){
    //   data[item].cart_qty = countval;

    //   if(this.vehicleType=='universal'){
    //     data[item].type = 'universal';
    //   }

    //   this.addedCart[0] = data;
    //   localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    //   this.getCart();
    // }else{
    //   this.toastr.error('Only '+data[item].spareStocks.quantity+' unit available for this item', 'Error');
    // }
    data = JSON.parse(localStorage.getItem('addedCart'))[0];
    // if(countval<=data[item].spareStocks.quantity){
      data[item].cart_qty = countval;
      this.addedCart[0] = data;
      // console.log("this.addedCart",this.addedCart)
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      this.getCart();
  }

  addCart(items, count){
    console.log("items",items);
    console.log("count",count);
    delete items.rowKey;
    delete items.variantKey;

    // if(this.isReplacePopup==true){
    //   sessionStorage.setItem('replaceCart', JSON.stringify(items));
    //   this.zone.run(() => {
    //     this.dialog.open(AspReplaceCartPopupComponent);
    //   });
    // }else{
    //   this.setNewMakeAsMake();
        
      this.addedCart = [];
      if(this.vehicleType=='universal'){
        items.type = 'universal';
      }
      if(localStorage.getItem('addedCart')){
        this.newData = JSON.parse(localStorage.getItem('addedCart'))[0];
        // console.log("items.cart_qty",items.cart_qty);
        items.cart_qty = count;
        this.amount=items.spareStocks;
        let make = localStorage.getItem('selectedMake');
        let model = localStorage.getItem('selectedModel');
        let registrationNumber = localStorage.getItem('registrationNumber');
        let variant = localStorage.getItem('variant');
        let mfgYear = localStorage.getItem('selectedYear');
        let fuelType = localStorage.getItem('selectedFuel');
        let rowKey = localStorage.getItem('rowKey');
        let variantKey = localStorage.getItem('variantKey');
        items = {
         
          ...items, 
          ...items.spareStocks, 
          selectedMake: make,
          selectedModel: model,
          registrationNumber: registrationNumber,
          variant: variant,
          selectedYear: mfgYear,
          selectedFuel: fuelType, 
          rowKey: rowKey, 
          variantKey: variantKey      
        };

        items.discount = items.discountAmount;  
        delete items.discountAmount;
        this.newData[items.key] = items;
        this.addedCart.push(this.newData);
        localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      }else{
        items.cart_qty = count;
        // this.amount=items.spareStocks;
        let make = localStorage.getItem('selectedMake');
        let model = localStorage.getItem('selectedModel');
        let registrationNumber = localStorage.getItem('registrationNumber');
        let variant = localStorage.getItem('variant');
        let mfgYear = localStorage.getItem('selectedYear');
        let fuelType = localStorage.getItem('selectedFuel');
        let rowKey = localStorage.getItem('rowKey');
        let variantKey = localStorage.getItem('variantKey');
        items = {
          ...items,
          ...items.spareStocks, 
          selectedMake: make,
          selectedModel: model,
          registrationNumber: registrationNumber,
          variant: variant,
          selectedYear: mfgYear,
          selectedFuel: fuelType,
          rowKey: rowKey, 
          variantKey: variantKey      
        };
        items.discount = items.discountAmount;  
        delete items.discountAmount;
        this.newData[items.key] = items;
        this.addedCart.push(this.newData);
        localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      }      
      this.getCart();
    // }
  }
  
  getCart(){
    let cartData;  
    this.cartList = [];
    this.cartCount = 0;
    this.cartSubTotal = 0;
    this.cartGrandTotal = 0;
    
    if(localStorage.getItem('addedCart')){   
      cartData = JSON.parse(localStorage.getItem('addedCart'));
      if(Object.keys(cartData[0]).length==0){
        this.isCartCount = false;
      } 
      
      Object.values(cartData[0]).forEach(cart => { 
        if(cart){
          this.isCartCount = true;
          this.cartCount++;
        

        // this.cartCount += cart['cart_qty'];
        if(cart['sellingPrice']>0){
          this.cartSubTotal += (cart['sellingPrice']*cart['cart_qty']);
        }else{
          this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        }
        this.cartList.push(cart);
      }
      });      

      this.cartList = cartData;
      this.cartGrandTotal = this.cartSubTotal;
      // console.log(this.cartList);

      // if(this.cartCount>0){
      //   (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
      // }else{
      //   (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
      // }
      if(this.sparesDiscount>0){
        this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
    }else{
        this.cartGrandTotal = this.cartSubTotal;
    }
    this.getShippingCharges()
  
    }
    // console.log("cartList",this.cartList)
  }
  getShippingCharges(){    
    // this.aspLoadingService.show();  
    let garageKey = localStorage.getItem('garageKey');
    this.aspCartService.getShippingCharges(this.cartGrandTotal, garageKey).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          // this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          // this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.grandAmount= res.data.cartValue;
          // this.aspLoadingService.hide(); 
            this.cartGrandTotal = this.grandAmount+this.shippingCharges;

            if(!this.isMobile){
              if(this.cartCount>0){
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
              }else{
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
              }
            }else{
              if(this.cartCount>0){
                (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
              }else{
                (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
              }
            }            
          
        } else {
          if(!this.isMobile){
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
            }
          }else{
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
            }
          }
        }
      }
    );
  }
  scrollServiceRight() {
  const container = document.querySelector('.avx-servicekit-slider');

  if (container) {
    container.scrollBy({ left: 250, behavior: 'smooth' });
  } else {
    console.error('Element not found: .avx-servicekit-slider');
  }
}

scrollServiceLeft() {
  const container = document.querySelector('.avx-servicekit-slider');

  if (container) {
    container.scrollBy({ left: -250, behavior: 'smooth' });
  } else {
    console.error('Element not found: .avx-servicekit-slider');
  }
}

callServiceKits() {
  this.loadingServiceKit = true;
  this.aspLoadingService.show();

  this.homeService.getServiceKits().subscribe(
    (res: any) => {

      if (res?.code === 200 && res?.data?.kits) {

        const kits = res.data.kits;

        // ✅ Remove duplicate brands + Fix discount
        const uniqueMap = new Map();

        kits.forEach((kit: any) => {

          const cleanTitle = this.cleanBrandName(kit.title);

          if (!uniqueMap.has(cleanTitle)) {

            uniqueMap.set(cleanTitle, {
              ...kit,
              title: cleanTitle,
              discount: Math.ceil(kit.discount || 0) // 🔥 FIX HERE
            });

          }
        });

        this.serviceKitList = Array.from(uniqueMap.values());

        // ✅ Clean + Short + Unique Tags
        const rawItems = res.data.kitItems || [];

        const shortTagSet = new Set<string>();

        rawItems.forEach((item: string) => {
          const shortName = this.getShortTagName(item);
          shortTagSet.add(shortName);
        });

        this.kitItems = Array.from(shortTagSet);
      }

      this.loadingServiceKit = false;
      this.aspLoadingService.hide();
    },
    () => {
      this.loadingServiceKit = false;
      this.aspLoadingService.hide();
    }
  );
}

cleanBrandName(title: string): string {

  if (!title) return '';

  return title
    .replace('Cars', '')
    .replace('cars', '')
    .trim();
}
getShortTagName(item: string): string {

  if (!item) return '';

  item = item.toLowerCase();

  if (item.includes('engine oil')) return 'Engine Oil';
  if (item.includes('air filter')) return 'Air Filter';
  if (item.includes('oil filter')) return 'Oil Filter';
  if (item.includes('coolant')) return 'Coolant';
  if (item.includes('brake oil')) return 'Brake Oil';

  return item;
}
openVehiclePopup() {
  this.isVehiclePopupOpen = true;
  document.body.style.overflow = 'hidden';
}

closeVehiclePopup() {
  this.isVehiclePopupOpen = false;
  document.body.style.overflow = 'auto';
}
acGas() {
  localStorage.setItem("selectedCategory",
    JSON.stringify({ "Air Conditioning": ["Refrigerant"] })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem("filterParams",
    JSON.stringify({ "subCategory": ["Refrigerant"], "brand": [] })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
airFilter() {
  localStorage.setItem("selectedCategory",
    JSON.stringify({ "Filters": ["Air Filter"] })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem("filterParams",
    JSON.stringify({ "subCategory": ["Air Filter"], "brand": [] })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
acFilter() {
  localStorage.setItem("selectedCategory",
    JSON.stringify({ "Filters": ["Cabin Filter"] })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem("filterParams",
    JSON.stringify({ "subCategory": ["Cabin Filter"], "brand": [] })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
essentialFluids() {
  localStorage.setItem("selectedCategory",
    JSON.stringify({ "Oils & Fluids": ["Additives","Brake Fluid","Coolant","Engine Oil","Transmission Oil"] })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem("filterParams",
    JSON.stringify({ "subCategory": ["Additives","Brake Fluid","Coolant","Engine Oil","Transmission Oil"], "brand": [] })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
wiperBlades() {
  localStorage.setItem("selectedCategory",
    JSON.stringify({
      "Windscreen Cleaning System": ["Wiper Blade", "Wiper Blade Set"]
    })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem("filterParams",
    JSON.stringify({
      "subCategory": ["Wiper Blade", "Wiper Blade Set"],
      "brand": []
    })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
windshieldWasherFluid() {

  localStorage.setItem(
    "selectedCategory",
    JSON.stringify({
      "Windscreen Cleaning System": ["Windshield Washer Fluid"]
    })
  );

  localStorage.setItem("selectedBrands", "[]");

  localStorage.setItem(
    "filterParams",
    JSON.stringify({
            // "subCategory": ["Connector Washer Fluid Pipe", "Rain Sensor","Washer Fluid Pipe", "Windshield Washer Bracket","Windshield Washer Fluid", "Windshield Washer Jet", "Windshield Washer Pump","Windshield Washer Reservoir", "Windshield Washer Reservoir Cap"],
      "subCategory": ["Windshield Washer Fluid"],
      "brand": []
    })
  );
  localStorage.setItem("isDynamicPopup", "true");
  this.router.navigate(['spare-parts-list']);
}
scrollGenuineLeft() {
  this.msCategoryRow.nativeElement.scrollBy({
    left: -200,
    behavior: 'smooth'
  });
}

scrollGenuineRight() {
  this.msCategoryRow.nativeElement.scrollBy({
    left: 200,
    behavior: 'smooth'
  });
}
selectGenuinePart(partName: string) {

  const filterMap: any = {

    "Oil Filter": {
      category: "Filters",
      subCategory: "Oil Filter"
    },

    "Air Filter": {
      category: "Filters",
      subCategory: "Air Filter"
    },

    "Spark Plug": {
      category: "Ignition and Glowplug System",
      subCategory: "Spark Plug"
    },

    "Front Bumper": {
      category: "Body",
      subCategory: "Bumper"
    },

    "Rear Bumper": {
      category: "Body",
      subCategory: "Bumper"
    },

    "Clutch Cover Assy": {
      category: "Clutch System",
      subCategory: "Clutch Pressure Plate"
    },

    "Clutch Release Bearing": {
      category: "Clutch System",
      subCategory: "Clutch Release Bearing"
    },

    "Clutch Disc Assy": {
      category: "Clutch System",
      subCategory: "Clutch Disc"
    },

    "Front Brake Disc": {
      category: "Brake System",
      subCategory: "Brake Disc"
    },

    "Front Brake Pad": {
      category: "Brake System",
      subCategory: "Brake Pads"
    },

    "AC Filter": {
      category: "Filters",
      subCategory: "Cabin Filter"
    },

    "Rear Shock Absorber": {
      category: "Suspension and Arms",
      subCategory: "Shock Absorber and Strut"
    },

    "Head Lamp - RH": {
      category: "Lighting",
      subCategory: "Headlight"
    },

    "Head Lamp - LH": {
      category: "Lighting",
      subCategory: "Headlight"
    }

  };

  const selectedFilter = filterMap[partName];

  if (!selectedFilter) {
    console.warn("No filter mapping found for:", partName);
    return;
  }

  const { category, subCategory } = selectedFilter;
      localStorage.setItem(
      "selectedSparesList",
      JSON.stringify({
        name: "Maruti Suzuki",
        type: "brandSpares",
        imageUrl: "",
        key: ""
      })
    );


  // ✅ Save Selected Category
  localStorage.setItem(
    "selectedCategory",
    JSON.stringify({ [category]: [subCategory] })
  );

  // ✅ Save Brand (must match API exactly)
  localStorage.setItem(
    "selectedBrands",
    JSON.stringify(["Maruti Suzuki"])
  );

  // ✅ Filter Params
  localStorage.setItem(
    "filterParams",
    JSON.stringify({
      category: [category],
      subCategory: [subCategory],
      brand: ["Maruti Suzuki"]
    })
  );

  localStorage.setItem("isDynamicPopup", "true");

  this.router.navigate(['spare-parts-list']);
}
marutiBrandSection() {
  this.aspLoadingService.show();

  this.homeService.getBrandSection().subscribe(
    (res: any) => {
      if (res?.code === 200 && res?.data?.length) {

        this.marutibrandSectionList = res.data.reduce((acc: any[], item: any) => {
          let brand = acc.find(b => b.brandName === item.brandName);

          if (!brand) {
            brand = { brandName: item.brandName, parts: [] };
            acc.push(brand);
          }

          brand.parts.push({
            id: item.id,
            partName: item.partName,
            imageUrl: item.imageUrl,
            status: item.status
          });

          return acc;
        }, []);

        // Select first brand (Maruti Suzuki)
        this.selectedBrand = this.marutibrandSectionList[0];
        this.updateDots();
        console.log('Processed Brand Section:', this.marutibrandSectionList);
      }

      this.aspLoadingService.hide();
    },
    (err) => {
      console.error('Brand Section API Error:', err);
      this.aspLoadingService.hide();
    }
  );
}
updateDots() {
  if (this.selectedBrand?.parts?.length) {
    this.msDotsArray = Array(this.selectedBrand.parts.length).fill(0);
  } else {
    this.msDotsArray = [];
  }
}
}


